// extracted by mini-css-extract-plugin
export default {"colorDot":"N19Z_u5K8MdJpIKEarkp","selected":"rq4uFyvVcoI6anfIshE6","withBorder":"LHsEwMzw49hEWsHkWVlR"};